module.exports = __webpack_public_path__ + "static/media/KaTeX_Main-Italic.767e06e1.ttf";